import type { DeepString } from "@/lib/i18n";

export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyList: "Brak realizacji do wyświetlenia.",
  categoriesAria: "Filtry kategorii realizacji",
  allCategories: "Wszystkie",
  readMore: "Zobacz ->",
  backToList: "<- Wszystkie realizacje",
  aboutBrand: "O marce",
  goals: "Wyzwania i cele",
  benefits: "Korzyści dla klienta",
  implementationProcess: "Jak przebiegało wdrożenie",
  description: "Informacje o realizacji",
  solutions: "Zakres prac",
  clientAboutRealization: "Klient o realizacji",
  gallery: "Galeria",
} as const;

export type CRealizationsTranslations = DeepString<typeof pl>;
